module.exports = __webpack_public_path__ + "static/media/article2.39364202.webp";